import { c as _c } from "react/compiler-runtime";
import { IcoChevronLeftBig24, IcoClose24 } from '@onefootprint/icons';
import { Dialog, IconButton } from '@onefootprint/ui';
import { useContext, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useStore } from 'zustand';
import { LEGACY_IDV_CONTAINER_ID, TOUCH_TARGET_CLASS } from '@/idv2/components/constants';
import { useNavigationHeaderPortalId } from '@/idv2/components/internal/gallery-portal-context';
import { type IDV2Store, StoreContext } from '@/idv2/features/idv-to-idv2';
import type { NavigationHeaderProps } from './types';
const NavigationHeader = t0 => {
  const $ = _c(65);
  const {
    leftButton,
    rightButton,
    content,
    position
  } = t0;
  const {
    t
  } = useTranslation("idv2");
  const store = useContext(StoreContext);
  const hideNavigationButtons = useStore(store, _temp);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [portalTarget, setPortalTarget] = useState(null);
  const [dialogContainer, setDialogContainer] = useState(null);
  const portalId = useNavigationHeaderPortalId();
  let t1;
  let t2;
  if ($[0] !== portalId || $[1] !== position) {
    t1 = () => {
      if (position !== "floating" && position !== "button-only") {
        setPortalTarget(document.getElementById(portalId));
      }
      setDialogContainer(document.getElementById(LEGACY_IDV_CONTAINER_ID));
    };
    t2 = [position, portalId];
    $[0] = portalId;
    $[1] = position;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useLayoutEffect(t1, t2);
  const shouldShowClose = leftButton?.variant === "close" && !hideNavigationButtons;
  const shouldShowBack = leftButton?.variant === "back" && !hideNavigationButtons;
  const staticTitle = content?.kind === "static" ? content.title : undefined;
  let t3;
  if ($[4] !== leftButton) {
    t3 = () => {
      if (leftButton?.variant !== "close") {
        return;
      }
      if (leftButton.confirmClose) {
        setShowConfirmDialog(true);
      } else {
        leftButton.onClose?.();
      }
    };
    $[4] = leftButton;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleClose = t3;
  let t4;
  if ($[6] !== leftButton || $[7] !== store) {
    t4 = () => {
      setShowConfirmDialog(false);
      if (leftButton?.variant === "close") {
        const onClose = leftButton.onClose ?? store?.getState().onClose;
        onClose?.();
      }
    };
    $[6] = leftButton;
    $[7] = store;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const handleConfirmClose = t4;
  if (!shouldShowBack && !shouldShowClose && !rightButton && !staticTitle) {
    let t5;
    if ($[9] !== portalTarget) {
      t5 = portalTarget ? null : <div className="relative flex items-center py-4 h-14 w-full" />;
      $[9] = portalTarget;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  let t5;
  if ($[11] !== handleClose || $[12] !== shouldShowClose || $[13] !== t) {
    t5 = shouldShowClose && <IconButton className={TOUCH_TARGET_CLASS} aria-label={t(_temp2)} icon={IcoClose24} onClick={handleClose} />;
    $[11] = handleClose;
    $[12] = shouldShowClose;
    $[13] = t;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== leftButton || $[16] !== shouldShowBack || $[17] !== t) {
    t6 = shouldShowBack && <IconButton className={TOUCH_TARGET_CLASS} aria-label={t(_temp3)} icon={IcoChevronLeftBig24} onClick={leftButton?.variant === "back" ? leftButton.onBack : undefined} />;
    $[15] = leftButton;
    $[16] = shouldShowBack;
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <div className="absolute left-0">{t5}{t6}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== staticTitle) {
    t8 = staticTitle && <div className="absolute inset-0 flex items-center justify-center pointer-events-none"><span className="text-label-2 text-primary">{staticTitle}</span></div>;
    $[22] = staticTitle;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== rightButton) {
    t9 = rightButton && <IconButton className={TOUCH_TARGET_CLASS} aria-label={rightButton.label ?? "Action"} icon={rightButton.icon} onClick={rightButton.onClick} />;
    $[24] = rightButton;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t9) {
    t10 = <div className="absolute right-0 flex items-center gap-2">{t9}</div>;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t7 || $[30] !== t8) {
    t11 = <div className="relative flex items-center py-4 h-14 w-full">{t7}{t8}{t10}</div>;
    $[28] = t10;
    $[29] = t7;
    $[30] = t8;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  const navContent = t11;
  let t12;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setShowConfirmDialog(false);
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== t) {
    t13 = t(_temp4);
    $[33] = t;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t) {
    t14 = t(_temp5);
    $[35] = t;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== handleConfirmClose || $[38] !== t14) {
    t15 = {
      label: t14,
      onClick: handleConfirmClose
    };
    $[37] = handleConfirmClose;
    $[38] = t14;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== t) {
    t16 = t(_temp6);
    $[40] = t;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = () => setShowConfirmDialog(false);
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== t16) {
    t18 = {
      label: t16,
      onClick: t17
    };
    $[43] = t16;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  let t19;
  if ($[45] !== t) {
    t19 = t(_temp7);
    $[45] = t;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t19) {
    t20 = <p className="text-body-2 text-secondary text-center">{t19}</p>;
    $[47] = t19;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== dialogContainer || $[50] !== showConfirmDialog || $[51] !== t13 || $[52] !== t15 || $[53] !== t18 || $[54] !== t20) {
    t21 = <Dialog open={showConfirmDialog} onClose={t12} title={t13} isConfirmation={true} size="compact" container={dialogContainer} primaryButton={t15} secondaryButton={t18}>{t20}</Dialog>;
    $[49] = dialogContainer;
    $[50] = showConfirmDialog;
    $[51] = t13;
    $[52] = t15;
    $[53] = t18;
    $[54] = t20;
    $[55] = t21;
  } else {
    t21 = $[55];
  }
  const dialog = t21;
  if (portalTarget) {
    let t22;
    if ($[56] !== navContent || $[57] !== portalTarget) {
      t22 = createPortal(navContent, portalTarget);
      $[56] = navContent;
      $[57] = portalTarget;
      $[58] = t22;
    } else {
      t22 = $[58];
    }
    let t23;
    if ($[59] !== dialog || $[60] !== t22) {
      t23 = <>{t22}{dialog}</>;
      $[59] = dialog;
      $[60] = t22;
      $[61] = t23;
    } else {
      t23 = $[61];
    }
    return t23;
  }
  let t22;
  if ($[62] !== dialog || $[63] !== navContent) {
    t22 = <>{navContent}{dialog}</>;
    $[62] = dialog;
    $[63] = navContent;
    $[64] = t22;
  } else {
    t22 = $[64];
  }
  return t22;
};
export default NavigationHeader;
function _temp(state) {
  return state.hideNavigationButtons;
}
function _temp2($) {
  return $.shell.global.components["navigation-header"]["close-button"]["aria-label"];
}
function _temp3($_0) {
  return $_0.shell.global.components["navigation-header"]["back-button"]["aria-label"];
}
function _temp4($_1) {
  return $_1.confirmationDialog.title;
}
function _temp5($_2) {
  return $_2.confirmationDialog.confirm;
}
function _temp6($_3) {
  return $_3.confirmationDialog.cancel;
}
function _temp7($_4) {
  return $_4.confirmationDialog.description;
}